import { render, staticRenderFns } from "./CommComment.vue?vue&type=template&id=cf5f4f96&"
import script from "./CommComment.vue?vue&type=script&lang=js&"
export * from "./CommComment.vue?vue&type=script&lang=js&"
import style0 from "./CommComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports